var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3476 6.79078C15.3476 4.88164 12.9535 3.33398 10.0003 3.33398C7.04713 3.33398 4.6531 4.88164 4.6531 6.79078C4.6531 8.6999 6.11143 9.75373 10.0003 9.75373C13.8892 9.75373 15.8337 10.7414 15.8337 13.2106C15.8337 15.6797 13.222 16.6673 10.0003 16.6673C6.77867 16.6673 4.16699 15.1197 4.16699 13.2106",
    stroke: "#1E201C",
    strokeWidth: 1.04167
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66602V18.3327",
    stroke: "#1E201C",
    strokeWidth: 1.04167
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar-icon.9a7b3efaafe9c66233372490d8f0df3f.svg";
export { ForwardRef as ReactComponent };